<template>
  <div class="d-flex flex-column align-items-center justify-content-center vh-100">
    <h1 class="mb-4">Voice Trainer</h1>
    <p class="lead mb-5">
      Ready to hear yourself speak spanish? Let's record your voice.
    </p>

    <h2>Record the following:</h2>
    <blockquote class="blockquote">
      <p class="mb-0">
        The quick brown fox jumps over the lazy dog. Sphinx of black quartz, judge my vow.
      </p>
    </blockquote>

    <button class="btn btn-primary btn-lg" @click="startRecording" :disabled="isRecording">Start Recording</button>
    <button class="btn btn-danger btn-lg mt-2" @click="stopRecording" :disabled="!isRecording">Stop Recording</button>

    <p class="mt-4">Make sure your microphone is enabled and working.</p>

    <audio v-if="audioUrl" controls :src="audioUrl"></audio>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      audioUrl: null,
    };
  },
  methods: {
    // Start recording
    async startRecording() {
      try {
        this.audioChunks = [];
        this.isRecording = true;
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        this.mediaRecorder = new MediaRecorder(stream);
        
        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data);
        };

        this.mediaRecorder.onstop = () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
          this.audioUrl = URL.createObjectURL(audioBlob);
          this.sendAudioToServer(audioBlob);
        };

        this.mediaRecorder.start();
      } catch (err) {
        console.error('Error starting the recording: ', err);
      }
    },

    // Stop recording
    stopRecording() {
      this.isRecording = false;
      this.mediaRecorder.stop();
    },

    // Send audio to the server
    async sendAudioToServer(audioBlob) {
      const formData = new FormData();
      formData.append('audio', audioBlob, 'voice-recording.wav');

      try {
        const response = await fetch('/your-server-endpoint', {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          console.log('Audio sent to the server successfully');
        } else {
          console.error('Error sending audio to the server');
        }
      } catch (err) {
        console.error('Error sending audio to the server:', err);
      }
    },
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
</style>
